var map = {
	"./f1.png": 20,
	"./f1_flipped.png": 47,
	"./gameoflife_1.png": 48,
	"./gameoflife_icon.png": 22,
	"./github.png": 49,
	"./gravity_1.png": 50,
	"./gravity_icon.png": 23,
	"./homepage_icon.png": 24,
	"./hypercatcursor_icon.png": 25,
	"./nordicreact_icon.png": 26,
	"./nordicwebbluetooth_icon.png": 27,
	"./npm.png": 51,
	"./piano_1.png": 52,
	"./piano_2.png": 53,
	"./piano_3.png": 54,
	"./piano_icon.png": 28,
	"./reactcourse_icon.png": 29
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21;